/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
export type Picklist_BadRequest_Fragment = {
	__typename?: 'BadRequest';
	errors: Array<string>;
};

export type Picklist_ReferenceResult_Fragment = {
	__typename?: 'ReferenceResult';
	results: Array<{ __typename?: 'Reference'; name: string; id: string }>;
};

export type PicklistFragment =
	| Picklist_BadRequest_Fragment
	| Picklist_ReferenceResult_Fragment;

export const PicklistFragmentDoc = gql`
	fragment Picklist on ReferenceResultBadRequest {
		... on ReferenceResult {
			results {
				id: code
				name
			}
		}
		... on BadRequest {
			errors
		}
	}
`;
